import { render, staticRenderFns } from "./paid-orders-statistics.vue?vue&type=template&id=e46e786e"
import script from "./paid-orders-statistics.vue?vue&type=script&lang=js"
export * from "./paid-orders-statistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports